// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19EN5","selected":"styles_selected__2fkJX"};